import "./Blog.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import Faqs from "../../components/Faqs/Faqs";
import SinglePost from "./BlogComponents/SinglePost";

const BlogDetails = () => {
  return (
    <>
      <NavBar />
      <SinglePost />
      <Faqs/>
      <Footer/>
    </>
  );
};


export default BlogDetails;
